import { useRef, useState } from "react";
import { FancyTitle } from "./components/fancyTitle";
import ImageGallery from "react-image-gallery";
import styled from "styled-components";
import { Arrow, InvertedArrow } from "./location";
import { VerticalLine } from "./components/lines";
import { useNuovoRistoranteQuery } from "../../generated/graphql";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px 120px;
  align-items: center;

  gap: 20px;
  .image-gallery-content .image-gallery-slide .image-gallery-image {
    max-height: calc(100vh - 300px);
  }
  img {
    width: 100%;
    height: auto;
    max-height: 60vh;
    object-fit: cover;
  }

  @media (max-width: 900px) {
    padding: 20px 0;
    ${Arrow} {
      display: none;
    }
  }
`;
const NumberCt = styled.div`
  font-family: "Caviar Dreams";
  font-style: normal;
  color: #a2a087;
  display: flex;
  flex-direction: row;
  gap: 15px;
`;
const Number = styled.div<{ active?: boolean }>`
  font-style: normal;
  transform: ${(props) => (props.active ? "translateY(-5px)" : "none")};
  cursor: pointer;
`;
export function FoodGallery() {
  const ref = useRef<ImageGallery>(null);

  const [currIndex, setCurrIndex] = useState<number>(0);
  const query = useNuovoRistoranteQuery();
  console.log(query.data, "dara");
  const images =
    query.data?.nuovoRistorante?.galleryCollection?.items.map((val) => ({
      original:
        `https://padel-resort.netlify.app/.netlify/images?url=${val?.url}&fm=webp&w=1000` ||
        "",
      thumbnail:
        `https://padel-resort.netlify.app/.netlify/images?url=${val?.url}&fm=webp&w=1000` ||
        "",
    })) || [];
  function nextSlide() {
    if (ref.current) {
      ref.current.slideToIndex(currIndex + 1);
    }
  }
  function prevSlide() {
    if (ref.current) {
      ref.current.slideToIndex(currIndex - 1);
    }
  }
  return (
    <>
      <br />
      <VerticalLine height='80px' />
      <FancyTitle text='FOOD GALLERY' double />
      <Container>
        <Arrow onClick={prevSlide} />

        <ImageGallery
          items={images}
          showThumbnails={false}
          showFullscreenButton={false}
          showNav={false}
          infinite={true}
          slideDuration={600}
          showPlayButton={false}
          useTranslate3D
          ref={ref}
          lazyLoad={false}
          onSlide={(val) => setCurrIndex(val)}
        />

        <InvertedArrow onClick={nextSlide} />
      </Container>
      <NumberCt>
        {images.map((val, index) => (
          <Number
            key={index}
            active={index === currIndex}
            onClick={() => ref.current?.slideToIndex(index)}>
            {index + 1}
          </Number>
        ))}
      </NumberCt>
    </>
  );
}
